// eslint-disable-next-line camelcase
import murmurhash3_32_gc from './murmurHash.js';
import {logError} from '../fingerprint.js';
import {noopLap} from './timings.js';

const TEXT_CACHE = 'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдеёжзийклмнопрстуфхцчшщъыьэюя' +
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ' +
    '`~1!2@3#4$5%6^7&8*9(0)-_=+[{]}|;:\',<.>/?' +
    '😀😁😂🤣😃😄😅😆😉😊😋😎😍😘😗😙😚🙂🤗🤔🤨😐😑😶🙄😏😣😥😮🤐😯😪😫🥱😴😌😛😜😝🤤😒😓😔😕🙃🤑😲☹️🙁😖😞😟😤😢😭😦😧😨😩🤯😬😰😱🥵🥶😳🤪😵😡😠🤬😷🤒🤕🤢🤮🤧😇🥳🥸🥺🤠';

// Холст 300 px (размер по умолчанию), а строка шириной ~2800 px: видны только первые ~30 символов.
// Невидимый хвост, особенно эмодзи, браузер всё равно раскладывает и растеризует — это основная
// стоимость Canvas (Windows Edge/Яндекс: 180–330 мс). Рисуем префикс, который заходит за край холста
// на MARGIN px: пиксели те же (проверено в Chrome, Firefox, WebKit, на стенде и в проде 1.3.0
// контрольной отрисовкой полной строки: 519 из 519 совпадений у клиентов без шума в canvas).
// До первого эмодзи только символы BMP без составных последовательностей: резать можно по любому индексу.
const SAFE_END = TEXT_CACHE.indexOf('😀');
const MARGIN = 64;

/**
 * Кратчайший префикс, правый край которого (второй fillText начинается с x = 4) заходит за край
 * холста на MARGIN px. Если даже весь участок до эмодзи не дотягивает (узкий шрифт), — полная строка.
 * @param {CanvasRenderingContext2D} ctx
 * @param {number} canvasWidth
 * @returns {string}
 */
function visibleText(ctx, canvasWidth) {
    const need = canvasWidth + MARGIN - 4;
    if (ctx.measureText(TEXT_CACHE.slice(0, SAFE_END)).width < need) {
        return TEXT_CACHE;
    }
    let lo = 1;
    let hi = SAFE_END;
    while (lo < hi) {
        const mid = (lo + hi) >> 1;
        if (ctx.measureText(TEXT_CACHE.slice(0, mid)).width >= need) {
            hi = mid;
        } else {
            lo = mid + 1;
        }
    }
    return TEXT_CACHE.slice(0, lo);
}

/**
 * @param {function(string)} lap Отметка этапа для замеров (timings.js).
 * @returns {string|null}
 */
function createCanvas(lap) {
    try {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Batch style settings
        Object.assign(ctx, {
            textBaseline: 'alphabetic',
            font: '14px \'Arial\'',
            fillStyle: '#f60',
        });

        ctx.fillRect(125, 1, 62, 20);

        const text = visibleText(ctx, canvas.width);
        lap('prefix');
        // Reduce style operations
        ctx.fillStyle = '#069';
        ctx.fillText(text, 2, 15);
        ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
        ctx.fillText(text, 4, 17);
        lap('draw');

        const dataUrl = canvas.toDataURL();
        lap('toDataURL');
        return dataUrl;
    } catch (e) {
        logError(e);
        return null;
    }
}

/**
 * @param {function(string)} lap Отметка этапа для замеров (timings.js).
 */
export default async function(lap = noopLap) {
    const html5Hash = murmurhash3_32_gc(createCanvas(lap));
    lap('hash');
    return {
        HTML5_HASH: html5Hash,
    };
}
